import { Modal } from 'antd'

import Check from 'components/Icons/Check'

import IconClose from 'components/Icons/Close'
import Button from 'components/UI/Buttom'

import './styles.scss'
import ErrorIcon from 'components/Icons/ErrorIcon'
import { useAccessibility } from 'context/hooks/useAccessibility'

interface ModalErrorBasesProps {
  visible: boolean
  handleOk: () => void
}

function ModalErrorBases({ visible, handleOk }: ModalErrorBasesProps) {
  const { contrastIsSelected } = useAccessibility()

  return (
    <Modal
      className={`containerModalErrorBases ${
        contrastIsSelected ? 'contrastMode' : ''
      }`}
      visible={visible}
      onCancel={handleOk}
      closable={false}
      style={{ top: '25%' }}
      bodyStyle={{
        backgroundColor: contrastIsSelected
          ? 'var(--contrast-background-color)'
          : 'var(--background)',
        ...(contrastIsSelected && {
          color: contrastIsSelected
            ? 'var(--contrast-foreground-color)'
            : '#2D4040',
        }),
        borderRadius: '10px',
        padding: '0',
      }}
      closeIcon={<IconClose size="14px" />}
      maskStyle={
        !contrastIsSelected
          ? { backgroundColor: 'rgba(45, 64, 64, 0.62)' }
          : { backgroundColor: 'var(--contrast-background-color)' }
      }
    >
      <div className="containerModalErrorBases__main">
        <ErrorIcon />
        <h1>Ocorreu um erro na busca</h1>
        <p>
          Não foi possível realizar sua busca devido a um erro. Por favor, tente
          novamente.
        </p>
        <hr />
        <div className="containerModalErrorBases__main--buttons">
          <Button
            title="Tentar novamente"
            type="primary"
            icon={<Check />}
            onClick={handleOk}
          />
        </div>
      </div>
    </Modal>
  )
}

export default ModalErrorBases
